/**
 * 后端菜单数组 → 转为vue‑router路由配置
 * 和vite版本完全一样，不用改动
 * @param {Array} backendMenuList 后端返回的菜单VO数组
 */
export function buildAsyncRoutes(backendMenuList) {
    return backendMenuList.filter(item=>item.path).map(item => {
        return {
            parentName: item.parentName,
            path: item.path,
            name: item.name,
            meta: item.meta,
            component: () => import(`@/components/load/${item.component}.vue`),
            children: item.children && item.children.length > 0
                ? buildAsyncRoutes(item.children)
                : []
        }
    })
}
